<template>
  <div :id="containerId" style="position: relative">

    <!--  ---------------------------- begin 图片左右换位置 ------------------------------------- -->
    <div class="movety-container" :style="{top:top+'px',left:left+'px',display:moveDisplay}" style="padding:0 8px;position: absolute;z-index: 91;height: 32px;width: 104px;text-align: center;">
      <div :id="containerId+'-mover'" :class="showMoverTask?'uploadty-mover-mask':'movety-opt'" style="margin-top: 12px">
        <a @click="moveLast" style="margin: 0 5px;"><a-icon type="arrow-left" style="color: #fff;font-size: 16px"/></a>
        <a @click="moveNext" style="margin: 0 5px;"><a-icon type="arrow-right" style="color: #fff;font-size: 16px"/></a>
      </div>
    </div>
    <!--  ---------------------------- end 图片左右换位置 ------------------------------------- -->
    <div v-if="isImageComp && fileList.length>0 && text!='点击上传'">{{ text }}</div>
    <a-upload
      name="file"
      :multiple="multiple"
      :action="getUploadAction()"
      :accept="accept"
      :headers="headers"
      :data="getUploadData"
      :fileList="fileList"
      :beforeUpload="beforeUpload"
      @change="handleChange"
      :disabled="disabled"
      :listType="complistType"
      :remove="handleClickRemove"
      @preview="handlePreview"
      :class="{'uploadty-disabled':disabled}">
      <template>
        <div v-if="isImageComp && fileList.length<number">
          <a-icon :type="icon" />
          <div class="ant-upload-text">{{ text }}</div>
        </div>
        <a-button-group v-if="!isImageComp && fileList.length<number">
          <a-button >
            <a-icon :type="icon" />{{ text }}
          </a-button>
          <!-- <a-button @click="handleHistory">
            <a-icon type="history" />
          </a-button> -->
        </a-button-group>
      </template>
    </a-upload>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
    <a-modal :visible="historyFileVisible" :footer="null" @cancel="handleHistoryCancel">
      <div
        v-infinite-scroll="onLoadMore"
        class="infinite-container"
        :infinite-scroll-disabled="busy"
        :infinite-scroll-distance="10"
      >
        <a-list item-layout="horizontal" size="small" :data-source="historyData">
          <!-- <div
            v-if="showLoadingMore"
            slot="loadMore"
            :style="{ textAlign: 'center', marginTop: '12px', height: '32px', lineHeight: '32px' }"
          >
            <a-spin v-if="loadingMore" />
            <a-button v-else @click="onLoadMore">
              更多
            </a-button>
          </div> -->
          <a-list-item slot="renderItem" slot-scope="item">
              <a-row>
                <a-col :span='15'><a :href="getDownloadUrl(item.filePath)" target="_blank">{{item.fileName}}</a></a-col>
                <a-col :span='4'>使用</a-col>
              </a-row>
          </a-list-item>
          <div v-if="loadingMore && !busy" class="loading-container">
            <a-spin />
          </div>
        </a-list>
      </div>
    </a-modal>
  </div>
</template>

<script>

  import Vue from 'vue'
  import { ACCESS_TOKEN, TENANT_CONFIG } from "@/store/mutation-types"
  import {getAction , postAction, deleteAction} from "@/api/manage"

  const FILE_TYPE_ALL = "all"
  const FILE_TYPE_IMG = "image"
  const FILE_TYPE_TXT = "file"

  const UPLOAD_TARGET_LOCAL = "local"
  const UPLOAD_TARGET_QINIU = "qiniu"
  const UPLOAD_TARGET_OSS = "oss"
  const UPLOAD_TARGET_COS = "cos"

  const uuidGenerator=()=>{
    var s = []
    var hexDigits = '0123456789abcdef'
    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
    }
    s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = '-'
    var uuid = s.join('')
    uuid = uuid.replace(/-/g,"")
    return uuid
  }
  const getFileName=(path)=>{
    if(path.lastIndexOf("\\")>=0){
      let reg=new RegExp("\\\\","g");
      path = path.replace(reg,"/");
    }
    return path.substring(path.lastIndexOf("/")+1);
  }
  export default {
    name: 'JUpload',
    data(){
      return {
        downloadUrl:{
          local: this.$store.getters.tenantInfo.staticDomain + '/',
          qiniu: this.$store.getters.tenantInfo.qiniuDomain + '/'
        },
        uploadAction:{
          local: window._CONFIG['domianURL']+"/sys/common/upload",
          qiniu: "//upload-" + this.$store.getters.tenantInfo.qiniuArea + ".qiniup.com",
          oss: "",
          cos: ""
        },
        tokenAction: {
          qiniu: "/common/qiniu/getToken"
        },
        headers:{},
        fileList: [],
        uploadToken: '',
        uploadKey: {},
        newFileList: [], //returnUrl为false时返回文件名称、文件路径及文件大小
        uploadGoOn:true,
        previewVisible: false,
        //---------begin 文件历史-----------
        historyFileVisible: false,
        showLoadingMore:true, //显示加载更多
        loadingMore: false, //加载更多状态
        busy: false,
        historyPage: 1,
        historyData:[],
        //-----------end 文件历史-----------
        //---------------------------- begin 图片左右换位置 -------------------------------------
        previewImage: '',
        containerId:'',
        top:'',
        left:'',
        moveDisplay:'none',
        showMoverTask:false,
        moverHold:false,
        currentImg:''
        //---------------------------- end 图片左右换位置 -------------------------------------
      }
    },
    props:{
      //按钮文本
      text:{
        type:String,
        required:false,
        default:"点击上传"
      },
      //按钮图标
      icon:{
        type:String,
        required:false,
        default:"upload"
      },
      //文件类型
      fileType:{
        type:String,
        required:false,
        default:FILE_TYPE_ALL
      },
      accept:{
         type:String,
         required:false,
      },
      //上传到的路径
      uploadPath: {
        type: String,
        require: false,
        default: ""
      },
      //文件名，不填则自动生成uuid作为文件名
      fileName: {
        type: String,
        require: false
      },
      // 最小文件尺寸KB
      minFileSize:{
        type: Number,
        required: false,
        default: 0
      },
      //最大文件尺寸（MB）
      maxFileSize:{
        type: Number,
        required: false,
        default: 1000
      },
      // 文件上传目标， 默认本地
      uploadTarget:{
        type: String,
        required: false,
        default: UPLOAD_TARGET_QINIU
      },
      /*这个属性用于控制文件上传的业务路径*/
      bizPath:{
        type:String,
        required:false,
        default:"temp"
      },
      //上传后的文件id
      value:{
        type:String,
        required:false
      },
      // update-begin- --- author:wangshuai ------ date:20190929 ---- for:Jupload组件增加是否能够点击
      disabled:{
        type:Boolean,
        required:false,
        default: false
      },
      //是否支持文件多选
      multiple:{
        type: Boolean,
        required: false,
        default: false
      },
      /**
       * update -- author:lvdandan -- date:20190219 -- for:Jupload组件增加是否返回url，
       * true：仅返回url
       * false：返回fileName filePath fileSize
       */
      returnUrl:{
        type:Boolean,
        required:false,
        default: true
      },
      //最大文件数量
      number:{
        type:Number,
        required:false,
        default: 999
      },
      //是否自动删除文件，点击删除按钮和文件数量溢出后会触发
      // 注意：自动删除可能会带来问题，如自动删除后，并没有保存表单，那么原文件就会丢失。
      autoDelete:{
        type:Boolean,
        required:false,
        default: true
      },
      //是否忽略租户
      ignoreTenant:{
        type:Boolean,
        required:false,
        default: false
      }
    },
    watch:{
      value:{
        immediate: true,
        handler() {
          let val = this.value
          if (val instanceof Array) {
            if(this.returnUrl){
              this.initFileList(val.join(','))
            }else{
              this.initFileListArr(val);
            }
          } else {
            this.initFileList(val)
          }
        }
      }
    },
    computed:{
      isImageComp(){
        return this.fileType === FILE_TYPE_IMG
      },
      complistType(){
        return this.fileType === FILE_TYPE_IMG?'picture-card':'text'
      }
    },
    created(){
      const token = Vue.ls.get(ACCESS_TOKEN);
      this.headers = {"X-Access-Token":token}
      //---------------------------- begin 图片左右换位置 -------------------------------------
      this.containerId = 'container-ty-'+new Date().getTime();
      //---------------------------- end 图片左右换位置 -------------------------------------
    },

    methods:{
      //获取上传目标地址
      getUploadAction(){
        switch(this.uploadTarget){
          case UPLOAD_TARGET_LOCAL:
            return this.uploadAction.local;
          case UPLOAD_TARGET_QINIU:
            return this.uploadAction.qiniu;
          case UPLOAD_TARGET_OSS:
            return this.uploadAction.oss;
          case UPLOAD_TARGET_COS:
            return this.uploadAction.cos;
          default:
            return this.uploadAction.local
        }
      },
      //获取下载链接
      getDownloadUrl(key){
        switch(this.uploadTarget){
          case UPLOAD_TARGET_LOCAL:
            return this.downloadUrl.local + key;
          case UPLOAD_TARGET_QINIU:
            return this.downloadUrl.qiniu + key;
          case UPLOAD_TARGET_OSS:
            return this.downloadUrl.oss + key;
          case UPLOAD_TARGET_COS:
            return this.downloadUrl.cos + key;
          default:
            return this.uploadAction.local + key;
        }
      },
      //获取要上传数据，提供给a-upload组件
      getUploadData(file){
        console.log("getUploadData");
        switch(this.uploadTarget){
          case UPLOAD_TARGET_LOCAL:
            return {'isup':1,'bizPath':this.bizPath};
          case UPLOAD_TARGET_QINIU:
            return {'token': this.uploadToken, 'key': this.uploadKey[file.uid]};
          case UPLOAD_TARGET_OSS:
            return {};
          case UPLOAD_TARGET_COS:
            return {};
          default:
              return {'isup':1,'bizPath':this.bizPath};
        } 
      },
      //获取七牛TOKEN
      getQiniuToken(){
        return new Promise((resolve, reject) => {
          getAction(this.tokenAction.qiniu, {}).then(res => {
            if(res.success){
              this.uploadToken = res.result
              resolve()
              return;
            }else{
              this.$message.error(res.message)
              reject()
            }
          })
        });
      },
      //获取文件key
      getFileFullName(file){
        let suffix = file.name.split(".")
        if(suffix.length>1){suffix = suffix.pop()}else{suffix = ""}
        let tenantId = this.ignoreTenant ? '' : this.$store.getters.tenantInfo.tenantId + '/'
        return  tenantId + this.uploadPath + 
        (this.fileName ? this.fileName : uuidGenerator()) + '.' + suffix
      },
      //获取文件信息
      getFilesInfo(ids){
        return postAction("/system/sysFile/queryByIds", {ids:ids})
      },
      //保存文件记录
      saveToDB(fileName, filePath,fileSize, fileLocation, fileTag){
          return postAction("/system/sysFile/add", {
            fileName: fileName,
            filePath: filePath,
            fileLocation: fileLocation,
            fileTag: fileTag,
            fileSize: fileSize
          })
      },
      //删除文件记录
      delFromBD(id){
          return deleteAction("/system/sysFile/delete", {
            id: id
          })
      },
      //从数组value生成文件列表
      initFileListArr(val){
        if(!val || val.length==0){
          this.fileList = [];
          return;
        }
        let fileList = [];
        for(var a=0;a<val.length;a++){
          let url = getDownloadUrl(val[a].filePath);
          fileList.push({
            uid:uuidGenerator(),
            name:val[a].fileName,
            status: 'done',
            url: url,
            response:{
              status:"history",
              message:val[a].filePath
            }
          })
        }
        this.fileList = fileList
      },
      //从value生成文件列表
      initFileList(paths){
        if(!paths || paths.length==0){
          this.fileList = [];
          return;
        }
        let fileList = [];
        let arr = paths.split(",")
        this.getFilesInfo(paths).then(res=>{
          if(res.success){
            res.result
            for(var a=0;a<res.result.length;a++){
              let f = res.result[a]
              if(f==null){
                console.log("文件不存在", a);
                continue;
              }
              fileList.push({
                uid:uuidGenerator(),
                name:f.fileName,
                status: 'done',
                url: f.fileUrl,
                response:{
                  status:"history",
                  message:arr[a]
                }
              })
            }
          }
          console.log(res);
        })
        this.fileList = fileList
      },
      handlePathChange(){
        let path = ''
        if(!this.fileList || this.fileList.length==0){
          path = ''
        }
        let arr = [];

        for(var a=0;a<this.fileList.length;a++){
          if(this.fileList[a].status === 'done' ) {
            arr.push(this.fileList[a].response.message)
          }else{
            return;
          }
        }
        if(arr.length>0){
          path = arr.join(",")
        }
        this.$emit('change', path);
      },
      //上传之前
      beforeUpload(file){
        this.uploadGoOn=true
        var fileType = file.type;
        console.log("file type :" + fileType);
        if(this.fileType===FILE_TYPE_IMG){
          if(fileType.indexOf('image')<0){
            this.$message.warning('请上传图片');
            this.uploadGoOn=false
            return false;
          }
        }
        if(file.size > this.maxFileSize * 1024 * 1024){
          this.$message.warning("文件不能超过"+this.maxFileSize+"MB")
          this.uploadGoOn=false
          return false
        }
        if(file.size < this.minFileSize * 1024){
          this.$message.warning("文件不能小于"+this.minFileSize+"KB")
          this.uploadGoOn=false
          return false
        }
        //获取文件key
        
        this.uploadKey[file.uid] = this.getFileFullName(file)
        this.$emit("selected", this.uploadKey[file.uid], file);

        //获取上传token
        switch(this.uploadTarget){
          case UPLOAD_TARGET_QINIU:
            return this.getQiniuToken();
          default:
            return true
        }
      },
      //上传完毕后文件列表发送变化
      handleChange(info) {
        if(!info.file.status && this.uploadGoOn === false){
          info.fileList.pop();
        }
        let fileList = info.fileList
        
        console.log("--文件列表改变--")
        console.log(info)
        if(this.number>0 && fileList.length>this.number){
          //删除超出部分文件
          this.handleDelete(fileList[0])
          fileList = fileList.slice(-this.number);
        }
        
        if(info.file.status==='done'){
          switch(this.uploadTarget){
            case UPLOAD_TARGET_LOCAL: //上传到本地
              if(info.file.response.success){
                fileList = fileList.map((file) => {
                  if (file.response && file.response.message) {
                    file.url = this.getDownloadUrl(file.response.message)
                    this.saveToDB(file.name,file.response.message, file.size,1,"后台上传")
                  }
                  return file;
                });
              }
              break
            case UPLOAD_TARGET_QINIU: //上传到七牛
              if(info.file.response && info.file.response.key){ //当上传成功后才会有key
                // fileList = fileList.map((file) => {
                for(var fi=0; fi<fileList.length; fi++){
                  var file = fileList[fi]
                  if (file.response && file.response.key) { // 有file.response.key说明是新上传的
                    this.saveToDB(file.name,file.response.key, file.size,2,"后台上传").then(res=>{
                      if(!res.success){this.$message.error(`${file.name} 上传数据库失败.`);}
                      let resFile = res.result
                      // file.response.message = file.response.key
                      file.url = resFile.fileUrl
                      file.response.message = resFile.id
                      this.handleDoneOrRemoved(file, fileList)
                      this.$emit("saved", res.result)
                      this.$message.success(`${info.file.name} 上传成功!`);
                      console.log(fileList)
                      console.log("--文件列表改变结束--")
                    })
                  }
                }
              }
          }
        }else if (info.file.status === 'error') {
          this.$message.error(`${info.file.name} 上传失败.`);
        }else if(info.file.status === 'removed'){
          this.handleDelete(info.file)
        }
        this.handleDoneOrRemoved(info.file, fileList)
      },
      
      handleDoneOrRemoved(file, fileList){
        this.fileList = fileList
         if(file.status==='done' || file.status === 'removed'){
            //returnUrl为true时仅返回文件路径
            if(this.returnUrl){
              this.handlePathChange()
            }else{
              //returnUrl为false时返回文件名称、文件路径及文件大小
              this.newFileList = [];
              for(var a=0;a<fileList.length;a++){
                // update-begin-author:lvdandan date:20200603 for:【TESTA-514】【开源issue】多个文件同时上传时，控制台报错
                if(fileList[a].status === 'done' ) {
                  var fileJson = {
                    fileName:fileList[a].name,
                    filePath:fileList[a].response.message,
                    fileSize:fileList[a].size
                  };
                  this.newFileList.push(fileJson);
                }else{
                  return;
                }
                // update-end-author:lvdandan date:20200603 for:【TESTA-514】【开源issue】多个文件同时上传时，控制台报错
              }
              this.$emit('change', this.newFileList);
            }
          }
      },
      handleClickRemove(file){
        if(this.autoDelete){
          if(window.confirm("确定从服务器删除文件？")){
            return true
          }else{
            return false
          }
        }
        return true
      },
      handleDelete(file){
        console.log("删除文件", file);
        if(file && file.response){
          if(this.autoDelete){
            this.delFromBD(file.response.message)
          }
          this.$emit('delete', file.response.message)
        }
        console.log(file)
      },
      handlePreview(file){
        if(this.fileType === FILE_TYPE_IMG){
          this.previewImage = file.url || file.thumbUrl;
          this.previewVisible = true;
        }else{
          window.open(file.url)
        }
      },
      handleCancel(){
        this.previewVisible = false;
      },
      handleHistory(e){
        e.stopPropagation()
        this.loadHistoryFile()
        this.historyFileVisible = true
      },
      handleHistoryCancel(){
        this.historyFileVisible = false;
      },



      //---------------------------- begin 图片左右换位置 -------------------------------------
      moveLast(){
        //console.log(ev)
        //console.log(this.fileList)
        //console.log(this.currentImg)
        let index = this.getIndexByUrl();
        if(index==0){
          this.$message.warn('未知的操作')
        }else{
          let curr = this.fileList[index].url;
          let last = this.fileList[index-1].url;
          let arr =[]
          for(let i=0;i<this.fileList.length;i++){
            if(i==index-1){
              arr.push(curr)
            }else if(i==index){
              arr.push(last)
            }else{
              arr.push(this.fileList[i].url)
            }
          }
          this.currentImg = last
          this.$emit('change',arr.join(','))
        }
      },
      moveNext(){
        let index = this.getIndexByUrl();
        if(index==this.fileList.length-1){
          this.$message.warn('已到最后~')
        }else{
          let curr = this.fileList[index].url;
          let next = this.fileList[index+1].url;
          let arr =[]
          for(let i=0;i<this.fileList.length;i++){
            if(i==index+1){
              arr.push(curr)
            }else if(i==index){
              arr.push(next)
            }else{
              arr.push(this.fileList[i].url)
            }
          }
          this.currentImg = next
          this.$emit('change',arr.join(','))
        }
      },
      getIndexByUrl(){
        for(let i=0;i<this.fileList.length;i++){
          if(this.fileList[i].url === this.currentImg || encodeURI(this.fileList[i].url) === this.currentImg){
            return i;
          }
        }
        return -1;
      },
      onLoadMore(){
        this.historyPage += 1
        this.loadHistoryFile()
      },
      loadHistoryFile(){
        this.loadingMore = true;
        this.busy = true
        getAction("/system/sysFile/list", {pageSize: 10, pageNo: this.historyPage}).then(res=>{
          if(res.success){
            if(res.result.records != null && res.result.records.length>0){
                this.historyData = this.historyData.concat(res.result.records)
                 this.busy = false
            }else{
                this.$message.warning('已全部加载');
            }
          }
          this.loadingMore = false;
        })
      }
    },
    mounted(){
      const moverObj = document.getElementById(this.containerId+'-mover');
      moverObj.addEventListener('mouseover',()=>{
        this.moverHold = true
        this.moveDisplay = 'block';
      });
      moverObj.addEventListener('mouseout',()=>{
        this.moverHold = false
        this.moveDisplay = 'none';
      });
      let picList = document.getElementById(this.containerId)?document.getElementById(this.containerId).getElementsByClassName('ant-upload-list-picture-card'):[];
      if(picList && picList.length>0){
        picList[0].addEventListener('mouseover',(ev)=>{
          ev = ev || window.event;
          let target = ev.target || ev.srcElement;
          if('ant-upload-list-item-info' == target.className){
            this.showMoverTask=false
            let item = target.parentElement
            this.left = item.offsetLeft
            this.top=item.offsetTop+item.offsetHeight-50;
            this.moveDisplay = 'block';
            this.currentImg = target.getElementsByTagName('img')[0].src
          }

        });

        picList[0].addEventListener('mouseout',(ev)=>{
          ev = ev || window.event;
          let target = ev.target || ev.srcElement;
          //console.log('移除',target)
          if('ant-upload-list-item-info' == target.className){
            this.showMoverTask=true
            setTimeout(()=>{
              if(this.moverHold === false)
                this.moveDisplay = 'none';
            },100)
          }
          if('ant-upload-list-item ant-upload-list-item-done' == target.className || 'ant-upload-list ant-upload-list-picture-card'== target.className){
            this.moveDisplay = 'none';
          }
        })
        //---------------------------- end 图片左右换位置 -------------------------------------
      }
    },
    model: {
      prop: 'value',
      event: 'change'
    }
  }
</script>

<style lang="less">
.uploadty-disabled{
  .ant-upload-list-item {
    .anticon-close{
      display: none;
    }
    .anticon-delete{
      display: none;
    }
  }
}
.infinite-container {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  overflow: auto;
  padding: 8px 24px;
  height: 500px;
}
.loading-container {
  position: absolute;
  bottom: 40px;
  width: 100%;
  text-align: center;
}
  //---------------------------- begin 图片左右换位置 -------------------------------------
  .uploadty-mover-mask{
    background-color: rgba(0, 0, 0, 0.5);
    opacity: .8;
    color: #fff;
    height: 28px;
    line-height: 28px;
  }
  //---------------------------- end 图片左右换位置 -------------------------------------
</style>